import { Injectable } from '@angular/core';
import { DataServiceConfig } from 'breeze-client';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type, @typescript-eslint/no-empty-interface
export interface BreezeLibraryConfig extends DataServiceConfig {}

@Injectable()
export class BreezeLibraryConfig {}
